import { useCallback, useEffect, useState } from "react";
import { useAppContext } from "./useAppContext";
import { useErrorHandling } from "./useErrorHandling";

enum AuthenticationChangedType {
	"Unknown" = 0,
	"FullToFull",
	"TempToTemp",
	"FullToTemp",
	"TempToFull",
}

export const useAccount = (): eXpress.core.IAccount => {
	const { context } = useAppContext();

	const { createFatalErrorHandler } = useErrorHandling();

	const getAccount = useCallback<() => eXpress.core.IAccount>(() => {
		return {
			id: context.account.id,
			type: context.account.type,
			name: context.account.name,
			shoppingCartId: context.account.shoppingCartId,
		};
	}, [context.account]);
	const [account, setAccount] = useState(getAccount);

	const handleAccountChangedAsync = useCallback(
		(type: AuthenticationChangedType) => {
			setAccount(getAccount());
			return Promise.resolve(type === AuthenticationChangedType.TempToFull);
		},
		[getAccount],
	);

	useEffect(() => {
		const authenticationWatcher = new eXpress.creator.AuthenticationWatcher({
			getAccount,
			errorHandlerCreator: () => createFatalErrorHandler(),
			handleAccountChangedAsync,
		});
		authenticationWatcher.start();
		return () => authenticationWatcher.dispose();
	}, [createFatalErrorHandler, getAccount, handleAccountChangedAsync]);

	return account;
};
